// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Fejlkode:",
    "error.search": "Søg i vores videnbase for at lære mere",
    dismiss: "afvis",
    "installation.title": "",
    "cancelation.button": "Annuller",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Initialiseringen mislykkedes",
      description: "Vi kunne ikke gengive siden. Kontakt support.",
    },
    "EOS-UI-UE": {
      title: "Der gik noget galt",
      description: "Der gik noget galt. Kontakt support.",
    },
    "EOS-IN-BC": {
      title: "Installationen mislykkedes",
      description: "Vi kunne ikke vise installationsforløbet. Kontakt support.",
    },
    "EOS-IN-UE": {
      title: "Installationen mislykkedes",
      description: "Der gik noget galt. Kontakt support.",
    },
    "EOS-IN-FF": {
      title: "Installationen mislykkedes",
      description:
        "Vi kunne ikke oprette forbindelse til Epic Online Services. Kontakt support.",
    },
    "EOS-IN-FF-*": {
      title: "Installationen mislykkedes",
      description:
        "Vi kunne ikke udføre anmodningen til Epic Online Services. Kontakt support.",
    },
    fallback: {
      title: "Der gik noget galt",
      description: "Der gik noget galt. Kontakt support.",
    },
  },
};
